import { defaultClient, retryClient } from '@api/client';

export const unlikePost = ({ id }) => {
  return retryClient.delete(`/posts/${id}/likes`);
};

export const deletePost = ({ id }) => {
  return defaultClient.delete(`/posts/${id}`);
};
